import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
    categoriesCollection: CategoriesModel[];
    search?: string | undefined;
    properties?: any;
    uri?: string;
    errorMessage?: string;
    categories?: string;
    hits?: number;
}

export interface CategoriesModel {
    title: string;
    image: string;
    url: string;
    subtitle: string;
}
export interface SYCategorySearchParameter extends ApiParameter {
    query?: string;
}

const url = "/api/v1/autocomplete";

export async function getCategoriesFromApi(search: SYCategorySearchParameter) {
    const response = await get<ApiResultModel>(`${url}`, search);
    return response;
}
